import moment from 'moment';

/**
 * Takes a moment object and then finds the utc offset and returns the value in minutes
 * @param {Date} momentObject
 */
const getOffsetTime = (timeStamp) => {
    const dateStringArray = timeStamp.toString().split(' ');
    let utcOffsetArray;
    let utcOffsetRaw;
    let operation;
    if (dateStringArray[5].includes('+')) {
        utcOffsetArray = dateStringArray[5].split('+');
        operation = '-';
        utcOffsetRaw = utcOffsetArray[1]
    } else {
        utcOffsetArray = dateStringArray[5].split('-');
        operation = '+';
        utcOffsetRaw = utcOffsetArray[1]
    }
    let hours = utcOffsetRaw.charAt(0) + utcOffsetRaw.charAt(1);
    let minutes = utcOffsetRaw.charAt(2) + utcOffsetRaw.charAt(3);
    let offset = (60 * hours) + Number(minutes);
    offset = operation === '-' ? offset * -1 : offset;

    return offset;
}

export default getOffsetTime;



// WEBPACK FOOTER //
// ./src/utils/getOffsetTime.js